module.exports = __webpack_public_path__ + "static/media/PLANETE_14827-NQ3ANC.0df8a48d.png";